import { Component, computed, inject, signal } from '@angular/core';
import { switchMap } from 'rxjs';
import { ToastService } from '../../core/services/toast/toast.service';
import { GbTheme, THEME_SIGNAL } from '../../interfaces/theme';
import { PaymentService } from '../../services/payment/payment.service';
import { RewardPointsService } from '../../services/reward-points/reward-points.service';

@Component({
  selector: 'app-copy-referral-code',
  imports: [],
  templateUrl: './copy-referral-code.component.html',
  styleUrl: './copy-referral-code.component.scss',
})
export class CopyReferralCodeComponent {
  public theme = inject(THEME_SIGNAL);

  public readonly GbTheme = GbTheme;

  public rewardPointsService = inject(RewardPointsService);

  public toastService = inject(ToastService);

  public paymentService = inject(PaymentService);

  public referralCode = computed(
    () => this.rewardPointsService.userRewardPointsData()?.referralCode || ''
  );

  public isCopied = signal(false);

  public async copyReferralCode() {
    const codeToCopy = this.referralCode();

    if (!codeToCopy) {
      return;
    }

    try {
      await navigator.clipboard.writeText(codeToCopy);
      this.isCopied.set(true);

      // Show success toast message
      this.toastService
        .openSuccessToast('reward_points.points_summary.referral_code_copied')
        .pipe(switchMap((toast) => toast.present()))
        .subscribe();

      setTimeout(() => {
        this.isCopied.set(false);
      }, 5000);
    } catch (err) {
      console.error('Failed to copy referral code to clipboard:', err);
      // Show error toast if copy fails
      this.toastService
        .openErrorToast('Failed to copy referral code. Please try again.')
        .pipe(switchMap((toast) => toast.present()))
        .subscribe();
    }
  }
}
